import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router";
import { useQuery, gql } from '@apollo/client';
import {
  Container, WideContainer, 
  Row, 
  Col,
  Img,
  Breadcrumb, BreadcrumbItem,
  Link,
} from './StyledComponents.js';
import styled from 'styled-components'
import moment from 'moment';
import {Helmet} from "react-helmet-async";
import { FacebookShareButton, FacebookIcon,
  PinterestShareButton, PinterestIcon, 
  TwitterShareButton, TwitterIcon } from "react-share";
import axios from 'axios';

import useWindowSize from './useWindowSize.js';
import altTextKes from './utils/altTextKes';
import UstBannerAd from './components/ads/UstBannerAd'
import MatchedContentAd from './components/ads/MatchedContentAd'
import { useCsEvent } from './client/useEvents.js';

const Metin = styled(Row)`
  font-size: 0.8em;
  background-color: rgb(246, 246, 246);
  white-space: pre-line;
  word-break: break-word;
`
const SayfaImageContainer = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 2000px;
`

export const loadData = (currentRoute, isSsr) => {
  const {id} = currentRoute.params
  console.debug("Kupur page load data", id);

  const headers = {};
  if (isSsr) 
    headers['Origin'] = 'server';

  return axios(`${process.env.REACT_APP_GA_API_URL}/kupur/${id}/`, {headers}).then((response) => {
    console.debug("Kupur data geldi", response.data);
    return response.data;
  }).catch((error) => {
    console.info("KupurPageComponenet data load failed", error.response.status);
    return {notFound: true};
  })
}

const gqlQuery = gql`
  query Kupur($id: String!) {
    kupur(id: $id) {
      id,
      dosya,
      sayfa {
        tarih,
        gazete,
        sayfa
      },
      gazete {
        gazete,
        gorunen_ad
      }
    }
  }
`

function KupurPageComponent(props)  {
  const {id} = props.match.params
  const windowSize = useWindowSize()
  const fireCsEvent = useCsEvent()

  console.debug("KupurPage params:", props.match.params, "windowSize:", windowSize);

  const {loading, errors, data} = useQuery(gqlQuery, {variables: {id}})

  const {kupur: kupurData} = data || {};
  const {sayfa: sayfaData, gazete: gazeteData} = kupurData || {}

  const renderTip = () => {
    return gazeteData.type == 'gazete' ? "Gazetesi" : "Dergisi";
  }
  let shareUrl = typeof window !== 'undefined' && window.location.href;
  const kupurImageUrl = () => {
    return `${process.env.REACT_APP_GA_CDN_URL}/kupurs/${kupurData.dosya}`;
  }
  const icerik = kupurData?.icerik?.replace(/(\n+ *)+/g, "\n");

  return <React.Fragment>
    <UstBannerAd />
    {kupurData && (<React.Fragment>
      <Helmet htmlAttributes={{itemscope:null , itemtype:"http://schema.org/Article"}} >
        <title>{`${gazeteData.gorunen_ad} ${moment(sayfaData.tarih).utc().format('LL')} Sayfa ${sayfaData.sayfa} küpürü | Gaste Arşivi`}</title>
        <meta itemProp="headline" 
            content={`${altTextKes(icerik, 110)}`}/>
        <meta name="description" 
            content={`${altTextKes(icerik, 300)}`}/>
        <meta name="og:title" itemProp="name"
            content={`${moment(sayfaData.tarih).utc().format('LL')} Tarihli ${gazeteData.gorunen_ad} ${renderTip()} küpürü`} />
        <meta name="og:description" 
            content={`${altTextKes(icerik, 300)}`} />
        <meta name="og:image" content={kupurImageUrl()} />
        <meta name="twitter:card" content={`summary_large_image`} />
        <meta name="twitter:image" content={kupurImageUrl()} />
        <meta name="twitter:description" 
            content={`${altTextKes(icerik, 200)}`} />
        <meta name="twitter:title" 
            content={`${moment(sayfaData.tarih).utc().format('LL')} Tarihli ${gazeteData.gorunen_ad} ${renderTip()} küpürü`} />
        <meta itemProp="datePublished" content={moment(sayfaData.tarih).utc().format()} />
        <meta itemProp="dateModified" content={moment(kupurData.last_updated).utc().format()} /> 
      </Helmet>
      <Container>
      <Row><Col>
        <nav aria-label="breadcrumb" className='d-flex justify-content-center'>
          <Breadcrumb className="breadcrumb">
            <BreadcrumbItem itemProp="publisher author" itemScope itemType="http://schema.org/Organization">
              <span itemProp="logo" itemScope itemType="https://schema.org/ImageObject">
                <meta itemProp="url" content={`${process.env.REACT_APP_GA_CDN_URL}/${gazeteData.logo}`} />
              </span>
              <Link itemProp="url" to={`/gazete/${gazeteData.gazete}`}><span itemProp="name">{gazeteData.gorunen_ad}</span></Link>
            </BreadcrumbItem>
            <BreadcrumbItem><Link to={`/gazeteSayisi/${gazeteData.gazete}/${moment(sayfaData.tarih).utc().format('YYYY-MM-DD')}`}>
              {moment(sayfaData.tarih).utc().format('YYYY-MM-DD')}
            </Link></BreadcrumbItem>
            <BreadcrumbItem><Link to={`/gazete/${gazeteData.gazete}/${moment(sayfaData.tarih).utc().format('YYYY-MM-DD')}/${sayfaData.sayfa}`}>Sayfa {sayfaData.sayfa}</Link></BreadcrumbItem>
            <BreadcrumbItem className="active" aria-current="page">Küpür</BreadcrumbItem>
          </Breadcrumb>
        </nav>
        <h2 className='d-flex justify-content-center'>
          {moment(sayfaData.tarih).utc().format('LL')} Tarihli {gazeteData.gorunen_ad} {renderTip()} Sayfa {sayfaData.sayfa}
        </h2>
      </Col></Row>
      </Container>
      <WideContainer>
      <Row>
        <SayfaImageContainer className="d-flex justify-content-center" >
        <Img itemProp="image" 
              src={kupurImageUrl()} 
              alt={altTextKes(icerik, 125)} 
              fluid />
        </SayfaImageContainer>
      </Row>
      <Row><Col className="d-flex justify-content-center" >
        <FacebookShareButton 
            className="m-1" 
            url={shareUrl}
            beforeOnClick={() => {
              fireCsEvent({
                category: 'Kupur',
                action: 'Share',
                label: 'Facebook'
              });
            }}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <PinterestShareButton className="m-1" 
            url={shareUrl}
            media={kupurImageUrl()}
            beforeOnClick={() => {
              fireCsEvent({
                category: 'Kupur',
                action: 'Share',
                label: 'Twitter'
              });
            }}>
          <PinterestIcon size={32} round/>
        </PinterestShareButton>
        <TwitterShareButton className="m-1" 
            url={shareUrl} 
            title={icerik && altTextKes(icerik.replace(/\s+/g, " "), 200)}
            beforeOnClick={() => {
              fireCsEvent({
                category: 'Kupur',
                action: 'Share',
                label: 'Twitter'
              });
            }}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </Col></Row>
      </WideContainer>
      <Container>
      {kupurData.icerik && 
        <Metin className="mt-5"><Col>
          <span>Metin içeriği (otomatik olarak oluşturulmuştur)</span>
          <p itemProp="articleBody">{icerik}</p>
        </Col></Metin>
      }
      </Container>
      </React.Fragment>
    ) || (
      <Row><Col className="mb-5 d-flex justify-content-center">
        <span role="status">Yükleniyor...</span>
      </Col></Row>
    )}
    <Row><Col>
      <MatchedContentAd />
    </Col></Row>
  </React.Fragment>
}

export default withRouter(KupurPageComponent);
